import { useState, useEffect } from 'react';
import getEjecutivosDetails from '../helpers/getEjecutivosDetails'

const useGetExecutiveDetails = (IDEjecutivo, Ffin, tipoPersona) => {

    const [state, setState] = useState({
        data: [],
        loadingData: true
    })

    useEffect( ()=>{
        getEjecutivosDetails(IDEjecutivo, Ffin, tipoPersona)
            .then( details => {
                setState({
                    data: details,
                    loadingData: false
                })
            } )
      },[IDEjecutivo, Ffin, tipoPersona])

    return state

}

export default useGetExecutiveDetails